import React from "react";
import { CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import '../VideoKyc/FaceCheckComponent.css';
import { useTranslation } from "react-i18next";

function FaceCheckComponent(props) {

  const getTitle = (resourcesList) => {
    var title = "";
    resourcesList.map((resourceTitle) => {
     title += resourceTitle.concat(" " +t(props.vsLabel)+ " ");
    })
    const result = title.slice(0, -3);
  
    return result;
  }
  const { t } = useTranslation("common");
  return (
    <>
      {
        props.List.map(list => (       
          <div  className="faceCheck_progress-chart-border col-md-4 col-lg-5 col-xl-4 col-xxl-3 col-sm-5">
            <div className="faceCheck_progress-chart p-2 d-md-flex justify-content-center ">
              <div className="faceCheck_chart_card_header">
                <CircularProgressbar
                  value={list.imageScore}
                  text={`${list.imageScore}%`}
                  strokeWidth={20}
                />
              </div>
              <span className="faceCheck_chart-status-label">{list.imageMatched === true ?<span className="chart-status-label-pass"> {t(props.passLabel)}</span> :<span className="chart-status-label-fail">{t(props.failLabel)}</span>}</span>
            </div>
            <div className="faceCheck_chart-title-footer">{getTitle(list.resourcesList)} 
            </div>
            <div className="faceCheck_chart-title-footer">{t(props.remarksLabel)} - {list.imageReviewRecommended}</div>
          </div>
        ))
      }
    </>
  );
}

export default  FaceCheckComponent;
